export default function currency(value = "") {
  if (!value) return "0";

  let number = parseFloat(value).toFixed(2);
  number = number.replace(".", ",");
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
